import { render } from "./BankAccount.vue?vue&type=template&id=6d4dc7be&scoped=true"
import script from "./BankAccount.vue?vue&type=script&lang=js"
export * from "./BankAccount.vue?vue&type=script&lang=js"

import "./BankAccount.vue?vue&type=style&index=0&id=6d4dc7be&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4dc7be"]])

export default __exports__